import React from "react";
import "../css/loading.scss";

const Loading = () => {
  return (
    <div className="loadingBar">
      <span className={`${"segment"} ${"seg1"}`}></span>
      <span className={`${"segment"} ${"seg2"}`}></span>
      <span className={`${"segment"} ${"seg3"}`}></span>
    </div>
  );
};

export default Loading;
